package com.hyperether.goodjob.scenes.register

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.StrokeCap
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.toScaleDp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FullScreenProgressBar() {
    val rotation = remember { Animatable(0f) }

    LaunchedEffect(Unit) {
        rotation.animateTo(
            targetValue = 360f,
            animationSpec = infiniteRepeatable(
                animation = tween(
                    durationMillis = 1500,
                    easing = LinearEasing
                ),
            )
        )
    }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.1f))
            .clickable(
                indication = null,
                interactionSource = remember { MutableInteractionSource() }
            ) { /* no-op */ },
        contentAlignment = Alignment.Center
    ) {
        CircularProgressIndicator(
            progress = { 0.8f },
            modifier = Modifier.background(Color.Transparent).rotate(rotation.value)
                .size(40.toScaleDp()),
            color = Color.Blue,
            strokeWidth = 4.toScaleDp(),
            trackColor = BlueApp,
            strokeCap = StrokeCap.Round,
        )
    }
}